// automatically generated by the FlatBuffers compiler, do not modify

export enum EscalatorGroupControl {
  AllRunUp = 0,
  AllRunDown = 1,
  AllStop = 2
}
